import {
  FilterDocument,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
  goalOtherID,
  GroupByMode,
  lifeAreaOtherID,
  SortingMode,
  TaskType,
} from '@griply/types';

export const defaultInboxFilterDocument: FilterDocument = {
  sortingMode: SortingMode.Custom,
  groupByMode: GroupByMode.None,
  filters: {
    [FilterOptionKeys.Tag]: null,
    [FilterOptionKeys.Priority]: null,
    [FilterOptionKeys.Duration]: null,
    [FilterOptionKeys.Goal]: {
      include: [goalOtherID],
      noTag: false,
    },
    [FilterOptionKeys.LifeArea]: {
      include: [lifeAreaOtherID],
      noTag: false,
    },
    [FilterOptionKeys.Date]: {
      type: FilterDocumentDateFilterTypes.NoDeadline,
      custom: null,
    },
    [FilterOptionKeys.Deadline]: {
      type: FilterDocumentDateFilterTypes.NoDeadline,
      custom: null,
    },
    [FilterOptionKeys.Type]: {
      include: [TaskType.Task],
      noTag: false,
    },
  },
};
